import { ResponseManipulatorHandler } from '../../../cache-logic-interface';
import { roomMessagesQueryManipulator } from './room-messages-query-manipulator';

export let dialogueMessageQueryManipulator: ResponseManipulatorHandler =
  roomMessagesQueryManipulator;
